// src/components/VeteranDeveloper.jsx
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import photo from '../developer.png'

export default function VeteranDeveloper() {
  const navigate = useNavigate()

  useEffect(() => { 
    window.scrollTo(0, 0)
    
    // Preload the image
    const img = new Image()
    img.src = photo
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      background: '#04060d',
      color: '#dce8f5',
      fontFamily: "'IBM Plex Sans', sans-serif",
      WebkitFontSmoothing: 'antialiased',
    }}>
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <link rel="preload" href={photo} as="image" />

      {/* ── NAV ── */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 10,
        height: 52, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 28px',
        background: 'rgba(4,6,13,0.9)', backdropFilter: 'blur(12px)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        </div>
        <button onClick={() => navigate('/')} style={{
          display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px',
          background: 'none', border: 'none',
          color: '#00d4b8', fontSize: 13, cursor: 'pointer',
          fontFamily: "'IBM Plex Mono', monospace", fontWeight: 500,
          transition: 'all .2s',
        }}
          onMouseEnter={e => { 
            e.currentTarget.style.background='rgba(0,212,184,0.1)'; 
            e.currentTarget.style.color='#00d4b8';
          }}
          onMouseLeave={e => { 
            e.currentTarget.style.background='none'; 
            e.currentTarget.style.color='#00d4b8';
          }}>
          ← Back to site
        </button>
      </div>

      {/* ── HERO ── */}
      <div style={{
        maxWidth: 780, margin: '0 auto',
        padding: '72px 28px 0',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        textAlign: 'center',
      }}>
        {/* Badge */}
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          padding: '5px 16px', borderRadius: 20,
          background: 'rgba(0,212,184,0.08)',
          border: '1px solid rgba(0,212,184,0.25)',
          fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
          color: '#00d4b8', letterSpacing: '0.1em', textTransform: 'uppercase',
          marginBottom: 32,
        }}>
          🇺🇸 Veteran Developer
        </div>

        {/* Photo */}
        <div style={{
          width: 140, height: 140, borderRadius: '50%',
          overflow: 'hidden', marginBottom: 28,
          border: '3px solid rgba(0,212,184,0.4)',
          boxShadow: '0 0 40px rgba(0,212,184,0.2), 0 20px 60px rgba(0,0,0,0.6)',
          flexShrink: 0,
        }}>
          <img 
            src={photo} 
            alt="Developer" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover',
            }} 
            loading="eager"
            decoding="async"
          />
        </div>

        {/* Name + title */}
        <h1 style={{
          fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 700,
          lineHeight: 1.1, letterSpacing: '-0.025em', marginBottom: 12,
        }}>
          The Mind Behind{' '}
          <span style={{
            background: 'linear-gradient(90deg, #00d4b8, #4d9de0)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>Netwoke</span>
        </h1>

        <p style={{
          fontSize: 16, color: 'rgba(220,232,245,0.5)',
          fontFamily: "'IBM Plex Mono', monospace",
          letterSpacing: '0.04em', marginBottom: 40,
        }}>
          Full-Stack Developer · Veteran · Privacy Advocate
        </p>
      </div>

      {/* ── MAIN CONTENT ── */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '0 28px 80px' }}>

        {/* Bio card */}
        <div style={{
          background: '#0d1220',
          border: '1px solid rgba(255,255,255,0.07)',
          borderRadius: 16, padding: '32px 36px',
          marginBottom: 24,
          position: 'relative', overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: 2,
            background: 'linear-gradient(90deg, #00d4b8, #4d9de0)',
          }} />
          <div style={{
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
            color: '#00d4b8', letterSpacing: '0.12em', textTransform: 'uppercase',
            marginBottom: 16,
          }}>About</div>
          <p style={{
            fontSize: 15, color: 'rgba(220,232,245,0.75)',
            lineHeight: 1.9, fontWeight: 300,
          }}>
            Dynamic and versatile professional with a degree in Computer Science and Information Systems.
            Proven expertise in full-stack software development, technical support, and strategic communication.
            Roles involve collaborating with multidisciplinary teams — including as part of unacknowledged CAP
            programs — to integrate complex systems, ensuring robust performance under unique operational conditions.
            Excel in both military and civilian environments, delivering top-tier technical solutions and customer service.
            Adept at managing complex projects, providing exceptional client support, and driving organizational
            success through innovative problem-solving and effective communication.
          </p>
        </div>

        {/* Why Netwoke */}
        <div style={{
          background: '#0d1220',
          border: '1px solid rgba(255,255,255,0.07)',
          borderRadius: 16, padding: '32px 36px',
          marginBottom: 24,
          position: 'relative', overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: 2,
            background: 'linear-gradient(90deg, #4d9de0, #3ecf8e)',
          }} />
          <div style={{
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
            color: '#4d9de0', letterSpacing: '0.12em', textTransform: 'uppercase',
            marginBottom: 16,
          }}>Why I Built Netwoke</div>
          <p style={{
            fontSize: 15, color: 'rgba(220,232,245,0.75)',
            lineHeight: 1.9, fontWeight: 300, marginBottom: 16,
          }}>
            After years working in environments where operational security and situational awareness were
            non-negotiable, I came home and looked at my personal Mac — and realized I had no idea what
            it was doing on the network. For someone trained to know exactly what's happening around them
            at all times, that was unacceptable.
          </p>
          <p style={{
            fontSize: 15, color: 'rgba(220,232,245,0.75)',
            lineHeight: 1.9, fontWeight: 300, marginBottom: 16,
          }}>
            I opened Activity Monitor one day and saw a process I didn't recognize making connections to
            servers in Germany on port 4444. There was no tool that could just tell me in plain English
            what that was, whether to worry about it, or how to stop it without a computer science degree.
          </p>
          <p style={{
            fontSize: 15, color: 'rgba(220,232,245,0.75)',
            lineHeight: 1.9, fontWeight: 300,
          }}>
            So I built the tool I always wanted. Netwoke is what happens when military-grade situational
            awareness thinking meets everyday Mac privacy. You shouldn't need to be a network engineer to
            know what your own computer is doing. That's the mission. A tool that runs silently in the background without 
            touching your system is a tool people trust and keep installed.
          </p>
        </div>

        {/* Stats row
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 12, marginBottom: 24,
        }}>
          {[
            { num: 'CS', label: 'Degree in Computer Science & Information Systems', color: '#00d4b8' },
            { num: '🇺🇸', label: 'United States Veteran', color: '#4d9de0' },
            { num: '🛡️', label: 'Privacy and user trust', color: '#3ecf8e' },
          ].map(({ num, label, color }) => (
            <div key={label} style={{
              background: '#0d1220',
              border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: 12, padding: '20px 16px',
              textAlign: 'center',
            }}>
              <div style={{
                fontSize: 28, fontWeight: 700, color,
                fontFamily: "'IBM Plex Mono', monospace",
                marginBottom: 8, lineHeight: 1,
              }}>{num}</div>
              <div style={{ fontSize: 11, color: 'rgba(220,232,245,0.45)', lineHeight: 1.5 }}>{label}</div>
            </div>
          ))}
        </div> */}

        {/* Buy me a coffee */}
        <div style={{
          background: 'rgba(245,166,35,0.05)',
          border: '1px solid rgba(245,166,35,0.2)',
          borderRadius: 16, padding: '28px 32px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 28, marginBottom: 12 }}>☕</div>
          <h3 style={{
            fontSize: 18, fontWeight: 600, marginBottom: 8,
            color: '#dce8f5', letterSpacing: '-0.01em',
          }}>
            Support the Developer
          </h3>
          <p style={{
            fontSize: 13, color: 'rgba(220,232,245,0.5)',
            lineHeight: 1.7, fontWeight: 300, marginBottom: 24, maxWidth: 420, margin: '0 auto 24px',
          }}>
            Netwoke is built and maintained by one person. If it's helped you understand or protect
            your network, buying a coffee goes a long way toward keeping the lights on and new
            features coming.
          </p>
          <a
            href="https://buymeacoffee.com/netwoke"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              padding: '13px 28px',
              background: 'linear-gradient(135deg, #f5a623, #e8940a)',
              borderRadius: 12, border: 'none',
              fontFamily: "'IBM Plex Sans', sans-serif",
              fontSize: 15, fontWeight: 700, color: '#04060d',
              textDecoration: 'none', letterSpacing: '-0.01em',
              boxShadow: '0 0 30px rgba(245,166,35,0.2), 0 8px 24px rgba(0,0,0,0.3)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 0 40px rgba(245,166,35,0.3), 0 12px 32px rgba(0,0,0,0.4)' }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 0 30px rgba(245,166,35,0.2), 0 8px 24px rgba(0,0,0,0.3)' }}
          >
            ☕ Buy Me a Coffee
          </a>
          <p style={{
            marginTop: 14, fontSize: 11,
            color: 'rgba(220,232,245,0.25)',
            fontFamily: "'IBM Plex Mono', monospace",
          }}>
            100% optional · every bit is appreciated
          </p>
        </div>

      </div>

      {/* ── FOOTER ── */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.07)',
        padding: '24px 28px', textAlign: 'center',
        fontSize: 11, color: 'var(--accent-teal)',
        fontFamily: "'IBM Plex Mono', monospace",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
      }}>
        <div style={{ fontSize: 11, color: 'var(--accent-teal)', fontFamily: "'IBM Plex Mono', monospace" }}>
          © {new Date().getFullYear()} Netwoke - Where Connection Meets Disclosure.
        </div>
        <div className="nw-footer-links" style={{ display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="https://x.com/netwokeapp" target="_blank" rel="noopener noreferrer"
            style={{ fontSize: 11, color: 'rgba(220,232,245,0.25)', fontFamily: "'IBM Plex Mono', monospace",
              cursor: 'pointer', transition: 'color .15s', textDecoration: 'none',
              display: 'flex', alignItems: 'center', gap: 5 }}
            onMouseEnter={e => e.currentTarget.style.color='rgba(220,232,245,0.5)'}
            onMouseLeave={e => e.currentTarget.style.color='rgba(220,232,245,0.25)'}>
            𝕏 @NetwokeApp
          </a>
          {['Privacy Policy'].map(l => (
            <span key={l} onClick={() => {
              if (l === 'Privacy Policy') window.location.hash = '#privacy'
            }}
              style={{ fontSize: 11, color: 'rgba(220,232,245,0.25)', fontFamily: "'IBM Plex Mono', monospace",
                cursor: 'pointer', transition: 'color 0.15s',
                textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4
              }}
              onMouseEnter={e => e.currentTarget.style.color='rgba(220,232,245,0.5)'}
              onMouseLeave={e => e.currentTarget.style.color='rgba(220,232,245,0.25)'}>
              {l}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
